import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesServicesListMain } from './modules/ui/Main';

const ServicesListPage = (
  <SuspensePage>
    <PagesServicesListMain />
  </SuspensePage>
);

export default ServicesListPage;
